import useSubJob from '@/use/useSubJob';
import {
  _primaryControls,
  _selectorControls,
  _increment,
  production_type,
  job_no,
  module_no,
  drawing_no,
  description,
  material_code,
  amount,
  unit,
  surface_treatment,
  target_date,
  _remarksControls,
  leadTime,
  _startDateControls,
  _finishDateControls,
  created_at,
  updated_at,
} from '@/table/Job/SubJob/base';
import { qc_production_amount } from './subJob-qc';

const { qcStatusClassMap, translateQCStatus } = useSubJob();

export default {
  types: {
    _primaryControls,
    _selectorControls,
    _increment,
    production_type,
    job_no,
    module_no,
    drawing_no,
    description,
    material_code,
    // _sizeControls: {
    //   name: 'ขนาดชิ้นส่วน',
    //   width: '10rem',
    // },
    size: {
      name: 'ขนาดชิ้นส่วน',
      width: '10rem',
    },
    amount,
    // withdrawn_amount,
    // purchased_amount,
    qc_production_amount,
    unit,
    // qc_status: {
    //   ...status,
    //   name: 'สถานะ',
    //   filter: (val: string, row: any) => translateQCStatus(row.item.qc_status),
    //   class: {
    //     text: (val: string, row: any) => qcStatusClassMap(row.item.qc_status),
    //   },
    // },
    surface_treatment,
    _startDateControls,
    _finishDateControls,
    target_date,
    _remarksControls,
    leadTime,
    created_at,
    updated_at,
  },
  sortable: [
    'production_type',
    'job_no',
    'module_no',
    'drawing_no',
    'description',
    'material_code',
    'amount',
    // 'withdrawn_amount',
    // 'purchased_amount',
    'unit',
    'qc_status',
    'surface_treatment',
    'target_date',
    'created_at',
    'updated_at',
  ],
};
